import styled from 'styled-components';
export const ModelOptionContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const ModelOptionHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const getModelOptionLabelStyle = (theme) => ({
    fontWeight: theme.fontWeights.semibold,
});
export const modelSelectorMenuStyles = {
    menu: {
        minWidth: '220px',
    },
};
export const modelSelectorAutoSwitchPopoverStyles = {
    root: {
        maxWidth: '320px',
    },
};
export const ModelAutoSwitchNoticeContent = styled.div `
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
